import { Space } from "antd";
import { FC } from "react";
import { Header } from "./header";
import { VehicleInventory } from "./vehicle-inventory";
import { MaintenanceSchedule } from "./maintenance-schedule";
import { Assignments } from "./assignments";
import { ExpenseTracking } from "./expense-tracking";
import { VesselModal } from "../vessel-modal";
import { ListShuttles } from "../list-shuttles";
import { useVesselStore } from "../store/vessel.store";

type Props = {};

export const ListVessels: FC<Props> = () => {
  const { listState } = useVesselStore();
  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Header />
      {listState === "vessels" ? <VehicleInventory /> : <ListShuttles />}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
        <MaintenanceSchedule />
        <Assignments />
      </div>
      <ExpenseTracking />
      <VesselModal />
    </Space>
  );
};
